export default __webpack_public_path__ + "static/media/forestly-noexpl-03_DE.a83ca443.png";